import StyleWrapper from 'publisher/components/core/StyleWrapper'
import React from 'react'
import { useCalculateButtonStyles } from 'src/publisher/shared/hooks/use-calculate-button-styles'
import {
  LinkButton as CommonLink,
  LinkButtonProps,
} from 'src/shared/components/button/link-button-new'
import { CommonButtonEntityInterface } from 'src/shared/schemas/buttons/common-button-entity.schema'

export interface BasePublisherLinkButtonProps
  extends Omit<LinkButtonProps, 'text' | 'attrId'> {
  entity: Omit<CommonButtonEntityInterface, 'type' | 'parentId'>
}

// TODO: reuse it in other button components
export const BasePublisherLinkButton = ({
  entity,
  ...props
}: BasePublisherLinkButtonProps) => {
  const {
    calculatedBorder,
    calculatedPadding,
    calculatedFontSize,
    calculatedLineHeight,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
    calculatedTextColor,
    calculatedBackground,
    calculatedHover,
  } = useCalculateButtonStyles({
    border: entity.border,
    mobileBorder: entity.mobileBorder,
    padding: entity.padding,
    mobilePadding: entity.mobilePadding,
    buttonType: entity.buttonType,
    fontSize: entity.textFontSize,
    mobileFontSize: entity.mobileTextFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    fontFamily: entity.textFontFamily,
    mobileFontFamily: entity.mobileTextFontFamily,
    fontWeight: entity.textFontWeight,
    mobileFontWeight: entity.mobileTextFontWeight,
    fontStyle: entity.textFontStyle,
    mobileFontStyle: entity.mobileTextFontStyle,
    textColor: entity.textColor,
    mobileTextColor: entity.mobileTextColor,
    background: entity.background,
    mobileBackground: entity.mobileBackground,
    backgroundColor: entity.backgroundColor,
    mobileBackgroundColor: entity.mobileBackgroundColor,
    hover: entity.hover,
    mobileHover: entity.mobileHover,
  })

  return (
    <StyleWrapper
      flex
      flexColumn
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
      appearance={entity.appearance}
    >
      <CommonLink
        iconClassNameBefore={entity.iconClassNameBefore}
        iconClassNameAfter={entity.iconClassNameAfter}
        text={entity.text}
        border={calculatedBorder.desktop}
        mobileBorder={calculatedBorder.mobile}
        subText={entity.subText}
        padding={calculatedPadding.desktop}
        mobilePadding={calculatedPadding.mobile}
        alignSelf={entity.alignSelf}
        mobileAlignSelf={entity.mobileAlignSelf}
        background={calculatedBackground.desktop}
        mobileBackground={calculatedBackground.mobile}
        attrId={entity.htmlAttrId}
        width={entity.width}
        mobileWidth={entity.mobileWidth}
        textColor={calculatedTextColor.desktop}
        subTextColor={entity.subTextColor}
        mobileTextColor={calculatedTextColor.mobile}
        mobileSubTextColor={entity.mobileSubTextColor}
        textFontSize={calculatedFontSize.desktop}
        mobileTextFontSize={calculatedFontSize.mobile}
        subTextFontSize={entity.subTextFontSize}
        mobileSubTextFontSize={entity.mobileSubTextFontSize}
        textFontFamily={calculatedFontFamily.desktop}
        textFontWeight={calculatedFontWeight.desktop}
        textFontStyle={calculatedFontStyle.desktop}
        lineHeight={calculatedLineHeight.desktop}
        subTextFontFamily={entity.subTextFontFamily}
        subTextFontWeight={entity.subTextFontWeight}
        subTextFontStyle={entity.subTextFontStyle}
        mobileTextFontFamily={calculatedFontFamily.mobile}
        mobileTextFontWeight={calculatedFontWeight.mobile}
        mobileTextFontStyle={calculatedFontStyle.mobile}
        mobileLineHeight={calculatedLineHeight.mobile}
        mobileSubTextFontFamily={entity.mobileSubTextFontFamily}
        mobileSubTextFontWeight={entity.mobileSubTextFontWeight}
        mobileSubTextFontStyle={entity.mobileSubTextFontStyle}
        boxShadow={entity.boxShadow}
        mobileBoxShadow={entity.mobileBoxShadow}
        hover={calculatedHover.desktop}
        mobileHover={calculatedHover.mobile}
        {...props}
      />
    </StyleWrapper>
  )
}
